export const getRoleAndPermissionsList = (profileRole) => [
  {
    value: 'dashboardViewer',
    role: 'Viewer',
    description: 'read-only access',
    disabled: false,
  },
  {
    value: 'dashboardEditor',
    role: 'Editor',
    description: 'user with read/write access',
    disabled: false,
  },
  {
    value: 'dashboardManager',
    role: 'Manager',
    description: 'user with read/write access, available to manage customer users',
    disabled: profileRole !== 'Manager' && profileRole !== 'Administrator' && profileRole !== 'Super Admin',
  },
  {
    value: 'dashboardAdmin',
    role: 'Administrator',
    description:
      'user with read/write access, available to manage customer users activate/deactivate equipment',
    disabled: profileRole !== 'Administrator' && profileRole !== 'Super Admin',
  },
];
